import i18next from 'i18next';
import { CUSTOM_TAGS_OPTIONS, PATIENT_CUSTOM_TAGS_OPTIONS } from '../Shared/CustomTags';
import permissions from '../../config/permissions';
import { INFO_PANE_PAGES } from '../../redux_store/reducer/reducers/infoPaneReducer';
import FILTER_TYPES from '../Shared/Table/widgets/Filters/constants';

const genderItems = [
  { label: i18next.t('forms:female'), value: 'female' },
  {
    label: i18next.t('forms:male'),
    value: 'male',
  },
];

export default genderItems;

export const PATIENT_LANGUAGE = {
  ENGLISH: 'english',
  SPANISH: 'spanish',
  UNKNOWN: 'unknown',
};

export const PATIENT_LANGUAGE_BY_KEY = {
  [PATIENT_LANGUAGE.ENGLISH]: 'English',
  [PATIENT_LANGUAGE.SPANISH]: 'Spanish',
  [PATIENT_LANGUAGE.UNKNOWN]: 'Unknown',
};

export const PATIENT_LANGUAGE_SELECTOR_OPTIONS = [
  {
    label: 'English',
    value: PATIENT_LANGUAGE.ENGLISH,
  },
  {
    label: 'Spanish',
    value: PATIENT_LANGUAGE.SPANISH,
  },
  {
    label: 'Unknown',
    value: PATIENT_LANGUAGE.UNKNOWN,
  },
];

export const PATIENTS_COLUMNS = [
  {
    size: 270,
    header: i18next.t('tables:accountCustomTags'),
    accessorKey: 'accountCustomTags',
    filter: {
      filterType: FILTER_TYPES.SELECT,
      options: CUSTOM_TAGS_OPTIONS,
    },
    cell: {
      withBubbles: true,
    },
    permission: permissions.ACCOUNTS_GET,
  },
  {
    size: 220,
    header: i18next.t('tables:account'),
    accessorKey: 'accountBusinessName',
    filter: {
      filterType: FILTER_TYPES.SELECT_WITH_DYNAMIC_HINT,
    },
    permission: permissions.ACCOUNTS_GET,
    enableHiding: false,
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:customTags'),
    accessorKey: 'customTags',
    filter: {
      filterType: FILTER_TYPES.SELECT,
      options: PATIENT_CUSTOM_TAGS_OPTIONS,
    },
    cell: {
      withBubbles: true,
    },
    permission: permissions.ACCOUNTS_GET,
  },
  {
    size: 200,
    header: i18next.t('tables:customId'),
    accessorKey: 'accountCustomIdentifier',
    filter: {},
    permission: permissions.ACCOUNTS_GET,
    enableHiding: false,
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:mrnNumber'),
    accessorKey: 'mrnNumber',
    filter: {},
    cell: {
      infoPanePage: INFO_PANE_PAGES.patient_page,
    },
  },
  {
    size: 200,
    header: i18next.t('tables:firstName'),
    accessorKey: 'firstName',
    filter: {},
    cell: {
      infoPanePage: INFO_PANE_PAGES.patient_page,
    },
  },
  {
    size: 200,
    header: i18next.t('tables:lastName'),
    accessorKey: 'lastName',
    filter: {},
    cell: {
      infoPanePage: INFO_PANE_PAGES.patient_page,
    },
  },
  {
    size: 200,
    header: i18next.t('tables:dateOfBirth'),
    accessorKey: 'dateOfBirth',
    filter: {
      filterType: FILTER_TYPES.DATE,
    },
    cell: {
      infoPanePage: INFO_PANE_PAGES.patient_page,
    },
  },
];
